import { render, staticRenderFns } from "./admin_tosdere.vue?vue&type=template&id=211193a4&"
import script from "./admin_tosdere.vue?vue&type=script&lang=js&"
export * from "./admin_tosdere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('211193a4', component.options)
    } else {
      api.reload('211193a4', component.options)
    }
    module.hot.accept("./admin_tosdere.vue?vue&type=template&id=211193a4&", function () {
      api.rerender('211193a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/admin_tosdere.vue"
export default component.exports